const filters = {
  filterStatus: (value) => {
    return {
      0: '未处理',
      1: '已处理'
    }[Number(value)]
  },
  filterStatus4: (value) => {
    return {
      0: '未认领',
      1: '未整改',
      2: '未核验',
      3: '已完成'
    }[Number(value)]
  },
  filterStatus2: (value) => {
    return {
      0: '已通过',
      1: '已拒绝'
    }[Number(value)]
  },
  filterStatus3: (value) => {
    return {
      0: '未转派',
      10: '转派中',
      20: '转派成功'
    }[Number(value)]
  },
  filterBrandName(value, brands) {
    return brands.some(item => String(item.brandId) === String(value))
      ? brands.find(item => String(item.brandId) === String(value)).brandName
      : undefined
  },
  filterAccuseTypes(value, replyTypeList) {
    if (!value) {
      return ''
    }
    let str = ''
    value.split(',').forEach(item => {
      const it = replyTypeList.find(i => String(i.id) === String(item))
      if (it) {
        str += `${it.title},`
      }
    })
    return str.slice(0, str.length - 1)
  },
  formatTime(msTime) {
    if (!msTime) {
      return '未整改'
    }
    const time = msTime / 1000
    const day = Math.floor(time / 60 / 60 / 24)
    const hour = Math.floor(time / 60 / 60) % 24
    const minute = Math.floor(time / 60) % 60
    const second = Math.floor(time) % 60
    if (day > 0) {
      return `${day}天${hour}时${minute}分${second}秒`
    } else {
      return `${hour}时${minute}分${second}秒`
    }
  },
  formatTime2(msTime) {
    if (msTime < 0 || msTime == '-') {
      return '-'
    }
    const time = msTime / 1000
    const day = Math.floor(time / 60 / 60 / 24)
    const hour = Math.floor(time / 60 / 60) % 24
    const minute = Math.floor(time / 60) % 60
    const second = Math.floor(time) % 60
    if (day > 0) {
      return `${day}天${hour}时${minute}分${second}秒`
    } else {
      return `${hour}时${minute}分${second}秒`
    }
  },
  filterRuleConfig(val) {
    if (!val) {
      return ''
    } else {
      return JSON.parse(val).title
    }
  },
  filterMoldStatus(value) {
    if (value) {
      return {
        100: '重点区域偏多调度',
        150: '普通区域偏多调度',
        200: '站外还车调度',
        250: '非法车辆调度'
      }[Number(value)]
    } else {
      return '-'
    }
  },
  filterMatchStatus(value) {
    if (value) {
      return {
        0: '未匹配',
        1: '自动匹配',
        2: '手动匹配'
      }[Number(value)]
    } else {
      return '-'
    }
  },
  filterMaintainGroup(value) {
    return {
      0: '非组成员',
      1: '勘察',
      2: '审核',
      3: '划线',
      4: '安装'
    }[Number(value)]
  },
  filterGroup(value) {
    return {
      0: '调度员',
      1: '勘察',
      2: '审核',
      3: '划线',
      4: '安装'
    }[Number(value)]
  },
  filterApplyStatus(value) {
    return {
      0: '处理中',
      1: '通过',
      2: '已拒绝'
    }[Number(value)]
  },
  filterApplyStationStatus(row, currTab) {
    const auditCurrent = Number(row.auditCurrent)
    const applyStatus = Number(row.applyStatus)
    if (auditCurrent === 2 && applyStatus === 0) {
      return '待审核'
    } else if (auditCurrent === 2 && applyStatus === 3) {
      return '审核拒绝'
    } else if (auditCurrent === 3 && applyStatus === 0) {
      return '待画线'
    } else if (auditCurrent === 3 && applyStatus === 3) {
      return '不可画线'
    } else if (auditCurrent === 4 && applyStatus === 0) {
      return '待安装'
    } else if (auditCurrent === 4 && applyStatus === 1) {
      return '已安装'
    }
  },
  filterClockStatus(value) {
    return {
      0: '不打卡',
      1: '打卡'
    }[Number(value)]
  },
  filterClockRole(value) {
    return {
      1: '运维员',
      2: '监管员'
    }[Number(value)]
  },
  getAreaNames(value, nationalArea) {
    let str = ''
    if (!value.regionId) {
      str = '全国'
    } else if (value.cityId) {
      // 省市区
      const provice = nationalArea.find(item => item.id === value.provinceId)
      const city = nationalArea.find(item => item.id === value.cityId)
      const region = nationalArea.find(item => item.id === value.regionId)
      str = `${provice.areaName} ${city.areaName} ${region.areaName}`
    }
    return str
  },
  getAreaNamesByAddress(value, nationalArea, userLevel, userSelfAreaId) {
    // 全国：省市区
    // 省：市区
    // 市：县区
    // 区：区
    let str = ''
    if (value.regionId === undefined || value.regionId === null) {
      return ''
    }
    if (value.regionId === '') {
      str = '全国'
      return str
    }
    const provice = nationalArea.find(item => String(item.id) === String(value.provinceId))
    const city = nationalArea.find(item => String(item.id) === String(value.cityId))
    const region = nationalArea.find(item => String(item.id) === String(value.regionId))
    if (String(userLevel) === '0') {
      if (String(userSelfAreaId) === '000000') {
        // 全国
        str = `${provice.areaName} ${city.areaName} ${region.areaName}`
      } else {
        // 省
        str = `${city.areaName} ${region.areaName}`
      }
    } else if (String(userLevel) === '1') {
      // 市
      str = `${region.areaName}`
    } else if (String(userLevel) === '2') {
      // 区县
      str = `${region.areaName}`
    }
    return str
  },
  getInvestigateName(value) {
    let txt = ''
    const v = Number(value)
    if (v === 0) {
      txt = '普通用户'
    } else if (v === 1) {
      txt = '勘察组'
    }
    return txt
  },
  // 扫一扫巡查日志-匹配状态
  filterInspectionMatchStatus(value) {
    if (value !== undefined && value !== null) {
      return {
        0: '未命中',
        1: '匹配成功',
        2: '多命中'
      }[Number(value)]
    } else {
      return '-'
    }
  },
  // 扫一扫巡查日志-巡查结果
  filterInspectionResult(value) {
    return {
      1: '合法车辆(已备案-已传数据)',
      2: '非法车辆(未备案-已传数据)',
      3: '未备案-未传数据',
      4: '已备案-未传数据',
      5: '无效二维码',
      6: '车管所二维码'
    }[Number(value)]
  },
  // 扫一扫巡查日志-角色类型
  filterInspectionRoleType(value) {
      return {
        1: '调度员',
        2: '监管员',
        3: '普通用户'
      }[Number(value)]
    },
  // 扫一扫巡查日志-巡查状态
  filterRecycleSwitchType(value) {
    return {
      0: '正常巡查',
      1: '仓库巡查'
    }[Number(value)]
  },
  // 嗅探巡查-嗅探类型
  filterBleType(value) {
    return {
      0: '移动嗅探',
      1: '设备嗅探'
    }[Number(value)]
  },
  // 脱敏手机号码
  hidePhoneNumber(phoneNumber) {
    // 假设电话号码是11位的
    return phoneNumber.slice(0, 3) + '****' + phoneNumber.slice(7)
  }
}

export default filters
